import {
  AllRolesResponseModel,
  CommonResponseModel,
  RolesData,
} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";

export class RoleService extends CommonAxiosService {
  private URL = "/roles";

  async createRole(payload: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/createRole", payload);
  }

  async updateRole(dto: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/updateRole", dto);
  }

  async getAllRoles(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAllRoles");
  }

  async getActiveAllRoles(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getActiveAllRoles")
}

  async activateOrDeactivateRole(payload: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/activateOrDeactivateRole", payload);
  }
}
